class Tags {
  /**
   * Format data to multiselect object
   *
   * @param tags
   * @returns {*}
   */
  static formatDataToMultiSelectObj(tags) {
    return tags.map(tag => ({
      name: tag.tag,
      code: tag.tagId,
    }));
  }
}

export default Tags;
